import Backbone from 'backbone';
import QasPopinView from './QasPopinView';
import Form from './FormValidator';
import { locale, pathname } from '../../../common/others/Configuration';
import $ from 'jquery';
import SharedDispatcher from '../../../common/others/SharedDispatcher';

/*Object.assign(adobeActions, {
  "RegistrationFrom": function (event, s) {
    return {
      label: 'Layer : Account creation : conf',
      vars: {
        linkTrackVars: 'events,eVar64',
        linkTrackEvents: 'event72',
        events: 'event72',
        eVar64: 'Layer'
      },
    };
  },
});*/

export default Backbone.View.extend({
  qasPopin: undefined,

  selectors: {
    form: '.js-registration-form',
    toggleContainer: '.js-toggle-container',
    toggleContent: '.js-toggle-content',
    toggleSwitch: '.js-onoffswitch-checkbox',
    passwordToggleContainer: '.js-expand-password',
    inputPassword: '.js-input-password',
    inputMail: '.js-input-mail',
    mailExistsError: '.js-email-exists',
    checkboxModifier: '.js-input-checkbox',
    allowMailHidden: '.js-allow-mail-hidden',
    allowMail: '.js-allow-mail',
    formContainer: '.js-form-content',
    particularContainer: '.js-particular',
    professionalContainer: '.js-professional',
    inputElement: '.js-form-input',
    documentContainer: '.js-document-container',
    disabledDocument: '.js-disabledDocument',
    fiscalTaxNumber: '.js-fiscal-number-type',
    childrenContainer: '.js-child-container',

    inputAddress: '.js-input-address',
    inputPostalCode: '.js-input-postalCode',
    inputCity: '.js-input-city',

    qasContainer: '.js-qas-popin-container',

    childrenDropdown: '.js-childNumber',

    selectCountry: '.js-select-country',
    stateDisplay: '.js-state-display',
    selectState: '.js-state-status',
    errorState: '.js-state-error',

    inputMember: '.js-input-member',
    errorMember: '.js-error-member',

    birthdateYear: '#Birthdate_Year',
    birthdateMonth: '#Birthdate_Month',
    birthdateDay: '#Birthdate_Day',
    hasCardSwitch: '#onoffswitch1',
    submitButton: '.js-registration-form input[type=submit]',
    alertingMailOptinCheckbox: '.js-alertingMailOptinCheckbox',
  },

  events: {
    'change .js-childNumber': 'onKidsChanged',
    'click .js-onoffswitch-checkbox': 'onToggled',
    'click .js-expand-password': 'onPasswordVisibilityChanged',
    'submit .js-registration-form': 'onSubmit',
    'change .js-input-checkbox': 'onCheckboxChecked',
    'change .js-allow-mail': 'onAllowMailChanged',
    'click .js-clientType-choice': 'onDisplayClientType',
    'change .js-document-type': 'onClientTypeChange',
    'keyup .js-input-mail': 'onMailChanged',
    'change .js-tc-company-radio': 'onTypeClientCompanyChanged',
    'change .js-tc-private-radio': 'onTypeClientCompanyChanged',
    'change .js-select-country': 'onCountryChanged',
    'change .js-select-member': 'onMemberChanged',
    'keyup .js-input-member': 'onMemberChanged',
    'keyup .js-disabledDocument .js-form-input': 'onBlurDocument',
    'change .js-checkbox-optin': 'onOptinChanged',
    'change  #Birthdate_Year': 'onBirthdateChanged',
    'change  #Birthdate_Month': 'onBirthdateChanged',
    'change  #Birthdate_Day': 'onBirthdateChanged',
    'click .js-adherentSwitchCheckbox': 'onAdherentSwitchCheckboxChange',
    'change .js-alertingMailOptinCheckbox': 'onAlertingMailOptinCheckboxChange',
  },

  initialize: function () {
    this.validator = new Form({ target: this.selectors.form });

    var self = this;

    this.initializeToggleSwitch();

    this.listenTo(SharedDispatcher, 'QAS:selected', this.onQasSelected);

    if ($(this.selectors.qasContainer)) {
      this.openQasPopin();
    }

    this.renderChildren();
    this.initializeActiveClientType();
    this.onBlurDocument();
    //this.setAllowMail();
    this._checkEmailValidity();

    if ($(this.selectors.formContainer).length) {
      this.listenTo(SharedDispatcher, 'registrationform:submit', this.onDisplayClientType);
    }
  },

  onAlertingMailOptinCheckboxChange: function (e) {
    var alertingMailOptinCheckbox = $(e.target);
    if (alertingMailOptinCheckbox.is(':checked')) {
      $(this.selectors.alertingMailOptinCheckbox).val('true');
    } else {
      $(this.selectors.alertingMailOptinCheckbox).val('false');
    }
  },

  onAdherentSwitchCheckboxChange: function (e) {
    var $target = $(e.target);
    var hasActiveCard = $target.is(':checked');
    if (hasActiveCard === false) {
      $(this.selectors.alertingMailOptinCheckbox).prop('checked', false);
      $(this.selectors.alertingMailOptinCheckbox).val('false');
    } else {
      $(this.selectors.alertingMailOptinCheckbox).prop('checked', true);
      $(this.selectors.alertingMailOptinCheckbox).val('true');
    }
  },

  // Fnac newsletters optin
  onOptinChanged: function (e) {
    var targetElement = $(e.currentTarget);
    var apiType = 'POST';
    // TODO move to account configuration
    var apiUrl = '/account/api/v1/news-letter/add';
    var apiKey = 'Fnac';

    var postData = [
      {
        key: apiKey,
        IsEnabled: targetElement.prop('checked'),
      },
    ];

    $.ajax({
      type: apiType,
      url: pathname + apiUrl,
      contentType: 'application/json',
      dataType: 'json',
      data: JSON.stringify(postData),
      success: function () {},
      error: function () {
        SharedDispatcher.trigger('flashmessage:show');
      },
    });
  },

  _checkEmailValidity: function () {
    var hasError = $(this.selectors.mailExistsError).hasClass('field-validation-error');

    if (hasError) {
      $(this.selectors.inputMail).attr('aria-invalid', 'true');
      $(this.selectors.inputMail).removeClass('valid');
      $(this.selectors.inputMail).addClass('error');
    }
  },

  initializeToggleSwitch: function () {
    var self = this;

    $(this.selectors.toggleSwitch).each(function () {
      var $container = $(this).parents(self.selectors.toggleContainer)[0];

      if ($(this).is(':checked')) {
        self.toggleContent($container, true);
      } else {
        self.toggleContent($container, false);
      }
    });
  },

  initializeActiveClientType: function () {
    $(this.selectors.disabledDocument).not('.active').find('.js-form-input').prop('disabled', true);

    if ($(this.selectors.professionalContainer).hasClass('active')) {
      this.onDocumentAttribution();
      $(this.selectors.disabledDocument).find('.js-form-select').prop('disabled', true);
      $(this.selectors.fiscalTaxNumber).prop('disabled', false);
    } else {
      this.renderClientTypeChange();
      $(this.selectors.disabledDocument).find('.js-form-select').prop('disabled', false);
      $(this.selectors.fiscalTaxNumber).prop('disabled', true);
    }
  },

  toggleContent: function (container, shouldShow) {
    var $content = $(container).children(this.selectors.toggleContent);

    if (shouldShow === true) {
      $content.show();
    } else {
      $content.hide();
    }
  },

  togglePasswordVisibility: function (input, value) {
    var inputPassword = input;
    var toggleContainer = $(this.selectors.passwordToggleContainer)[0];

    if (!toggleContainer) {
      return;
    }

    var type = $(inputPassword).attr('type');

    if (value === false) {
      $(toggleContainer).removeClass('pwd--active');
      $(inputPassword).attr('type', 'password');
    } else {
      $(toggleContainer).addClass('pwd--active');
      $(inputPassword).attr('type', 'text');
    }
  },

  toggleDisplayClient: function (elementType) {
    var clientSelection = elementType.attr('data-client-type');

    if (elementType.is(':checked')) {
      $(this.selectors.formContainer).removeClass('active').hide();
      $(this.selectors.formContainer).find('.js-form-input').val('').prop('disabled', true);
      $('.' + clientSelection)
        .find('.js-form-input')
        .prop('disabled', false);
      $('.' + clientSelection)
        .removeClass('hidden')
        .show();

      if (clientSelection == 'js-professional') {
        this.onDocumentAttribution();
        $(this.selectors.disabledDocument).find('.js-form-select').prop('disabled', true);
        $(this.selectors.fiscalTaxNumber).prop('disabled', false);
      } else {
        this.renderClientTypeChange();
        $(this.selectors.disabledDocument).find('.js-form-select').prop('disabled', false);
        $(this.selectors.fiscalTaxNumber).prop('disabled', true);
      }
    }
  },

  openQasPopin: function () {
    // - Open QAS
    //
    var isValid = this.isAddressFilled();

    if (isValid) {
      this.qasPopin = new QasPopinView();
      this.qasPopin.open();
    }
  },

  setAllowMail: function () {
    var $element = $(this.selectors.allowMail);

    if ($element.is(':checked')) {
      $(this.selectors.allowMailHidden).val('False');
    } else {
      $(this.selectors.allowMailHidden).val('True');
    }
  },

  isAddressFilled: function () {
    var inputAddressVal = $(this.selectors.inputAddress).val();
    var inputPostalCodeVal = $(this.selectors.inputPostalCode).val();
    var inputCityVal = $(this.selectors.inputCity).val();

    if (!inputAddressVal || !inputPostalCodeVal || !inputCityVal) {
      return false;
    }

    return inputAddressVal.trim().length > 0 && inputPostalCodeVal.trim().length > 0 && inputCityVal.trim().length > 0;
  },

  renderChildren: function () {
    var selectedValue = $(this.selectors.childrenDropdown).val();

    var elementsToShow = $(this.selectors.childrenContainer).filter(function () {
      return parseInt($(this).attr('data-index')) <= selectedValue;
    });

    var elementsToHide = $(this.selectors.childrenContainer).filter(function () {
      return parseInt($(this).attr('data-index')) > selectedValue;
    });

    elementsToHide.hide();
    elementsToShow.show();

    elementsToShow.removeClass('hide');

    jQuery.each(elementsToShow, function (index, value) {
      $(value)
        .find('input:text, input:radio, select')
        .each(function () {
          $(this).attr('disabled', false);
        });
    });

    jQuery.each(elementsToHide, function (index, value) {
      $(value)
        .find('input:text, input:radio, select')
        .each(function () {
          $(this).attr('disabled', true);
        });
    });
  },

  renderCompanyContent: function (selector) {
    var $content = $('.js-tc-company-content');
    if (!selector.length || !$content) {
      return;
    }

    if (selector.hasClass('js-tc-company-radio') && selector.is(':checked')) {
      $content.removeClass('hidden');
    } else if (selector.hasClass('js-tc-private-radio') && selector.is(':checked')) {
      $content.addClass('hidden');
    }
  },

  renderClientTypeChange: function () {
    var optionDocument = $(this.selectors.particularContainer).find('.js-document-type option:selected'),
      optionDocumentReg = optionDocument.attr('data-regex'),
      labelDocument = $(this.selectors.particularContainer).find('.js-document-label'),
      inputDocument = $(this.selectors.particularContainer).find('.js-form-input');

    if (optionDocument.text() === 'Tipo de cliente') {
      $(this.selectors.particularContainer).find(this.selectors.documentContainer).addClass('hidden');
    } else {
      labelDocument.text(optionDocument.text());
      $(this.selectors.documentContainer).removeClass('hidden');
      inputDocument.prop('disabled', false);
      inputDocument.focus();
      inputDocument.rules('add', { regex: '^' + optionDocumentReg });
    }
  },
  // - Events
  //
  onToggled: function (e) {
    var $target = $(e.target);
    var shouldShow = $target.is(':checked');
    var $container = $target.parents(this.selectors.toggleContainer)[0];

    this.onBirthdateChanged();

    this.toggleContent($container, shouldShow);
  },

  onKidsChanged: function () {
    this.renderChildren();
  },

  onPasswordVisibilityChanged: function () {
    var inputPassword = $(this.selectors.inputPassword);
    this.togglePasswordVisibility(inputPassword, inputPassword.attr('type') === 'password');
  },

  onSubmit: function (e) {
    //TODO
    //trackEvent({ action: "RegistrationFrom", target: e.currentTarget });
  },

  onQasSelected: function (obj) {
    $(this.selectors.inputAddress).val(obj.Address);
    $(this.selectors.inputPostalCode).val(obj.ZipCode);
    $(this.selectors.inputCity).val(obj.City);

    if (this.qasPopin) {
      this.qasPopin.close();
      this.qasPopin = undefined;
    }
  },

  onAllowMailChanged: function () {
    this.setAllowMail();
  },

  onDisplayClientType: function (e) {
    this.toggleDisplayClient($(e.target));
  },

  onClientTypeChange: function () {
    this.renderClientTypeChange();
  },

  onMailChanged: function () {
    this._clearEmailExistField();
  },

  onTypeClientCompanyChanged: function (e) {
    this.renderCompanyContent($(e.target));
  },

  onCountryChanged: function () {
    // Display state field (Provincia) if country is Espa�a (Pen�nsula)
    if ($(this.selectors.selectState) && $(this.selectors.selectCountry).find(':selected').val() === '197') {
      $(this.selectors.selectState).attr('disabled', false);
      $(this.selectors.stateDisplay).removeClass('hide');
    } else {
      // Remove error message and hide state field
      $(this.selectors.stateDisplay).addClass('hide');
      $(this.selectors.selectState).attr('disabled', true);
    }

    if ($(this.selectors.professionalContainer).is(':visible')) {
      this.onDocumentAttribution();
    }
  },

  onDocumentAttribution: function () {
    //recovery of the data tax number
    var selectCountry = $(this.selectors.selectCountry).find('option:selected'),
      taxNumberAttribution = selectCountry.attr('data-taxnumber-country'),
      taxNumberRegex = selectCountry.attr('data-taxnumber-regex'),
      labelProfessionalDocument = $(this.selectors.professionalContainer).find('.js-document-label'),
      inputProfessionalDocument = $(this.selectors.professionalContainer).find('.js-form-input'),
      inputFiscalNumber = $(this.selectors.professionalContainer).find('.js-fiscal-number-type');

    inputProfessionalDocument.focus();

    switch (taxNumberAttribution) {
      case 'ES':
        labelProfessionalDocument.text('CIF');
        inputFiscalNumber.val('3');
        inputProfessionalDocument.rules('add', { regex: '^[A-Z]{1}[0-9]{7}[A-Z0-9]{1}$' });
        break;
      case 'CEE':
        inputProfessionalDocument.rules('add', { regex: '^' + taxNumberRegex });
        labelProfessionalDocument.text('NIF Intracomunitario');
        inputFiscalNumber.val('5');
        break;
      default:
        labelProfessionalDocument.text('N° fiscal');
        inputProfessionalDocument.rules('add', { regex: '^.*' });
        inputFiscalNumber.val('6');
        break;
    }
  },

  onMemberChanged: function () {
    $(this.selectors.form).valid();
    $(this.selectors.inputMember).removeClass('error');
    $(this.selectors.errorMember).empty();
  },

  _clearEmailExistField: function () {
    $(this.selectors.mailExistsError).removeClass('field-validation-error');
    $(this.selectors.mailExistsError).html('');
  },

  onBlurDocument: function () {
    $(this.selectors.disabledDocument)
      .find(this.selectors.inputElement)
      .val(function () {
        return this.value.toUpperCase();
      });
  },

  onBirthdateChanged: function () {
    if (locale == 'fr-FR') {
      if ($(this.selectors.hasCardSwitch).is(':checked')) {
        var year = $(this.selectors.birthdateYear).val();
        var month = $(this.selectors.birthdateMonth).val();
        var day = $(this.selectors.birthdateDay).val();
        if (year && month && day) {
          const BirthdayDate = new Date(year, month - 1, day);
          const MinimumBirthDate = new Date(new Date().getFullYear() - 14, new Date().getMonth(), new Date().getDate());
          if (BirthdayDate > MinimumBirthDate) {
            $('.js-birthdate-error-message').removeClass('hide');
            $(this.selectors.submitButton).prop('disabled', true);
          } else {
            $('.js-birthdate-error-message').addClass('hide');
            $(this.selectors.submitButton).prop('disabled', false);
          }
        }
      }
    }

    if (!$(this.selectors.hasCardSwitch).is(':checked')) {
      $('.js-birthdate-error-message').addClass('hide');
      $(this.selectors.submitButton).prop('disabled', false);
    }
  },
});
